import { isMobile } from "@classdojo/web";
import { NessieThemeColors } from "@classdojo/web/nessie/components/theme";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import { IdeasCloseIcon } from "components/IdeasIcons";
import FocusTrap from "focus-trap-react";
import React from "react";

interface PresentationPageProps {
  onRequestHide?: VoidFunction;
  backgroundColor: NessieThemeColors;
  closeButtonStyle?: ThemeUIStyleObject;
  closeButtonAriaLabel?: string;
  className?: string;
}

/*
 * Wrapper around all receiver display/result screens
 */
const PresentationPage = (props: React.PropsWithChildren<PresentationPageProps>) => {
  const { backgroundColor, closeButtonStyle, onRequestHide, closeButtonAriaLabel } = props;
  return (
    <FocusTrap active={!isMobile.any}>
      <div sx={{ backgroundColor, ...presentationPageStyle }} className={props.className}>
        {onRequestHide && (
          <button
            data-name="presentation_page:render:other_actions_close"
            onClick={onRequestHide}
            sx={{
              position: "fixed",
              zIndex: 9999,
              top: "0",
              right: "0",
              margin: RAW_cssValue("24px"),
              background: "transparent",
              border: "none",
              ...closeButtonStyle,
            }}
          >
            <IdeasCloseIcon
              aria-label={closeButtonAriaLabel || autoTranslate("Close")}
              size="m"
              color={closeButtonStyle?.color || "dt_content_light"}
            />
          </button>
        )}
        {props.children}
      </div>
    </FocusTrap>
  );
};

const presentationPageStyle: ThemeUIStyleObject = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  minHeight: "100vh",
  color: "dt_content_light",
};

export default PresentationPage;
